module.exports = __webpack_public_path__ + "../resources/images/calendar_drophint_bw-7efdf58ab7a6e8f994fb1da22e39230a.svg";